import { CandidateTopper } from '@tempmee/react-blocks';
import { DetailsPanel } from '~/components/shared/DetailsPage';

export interface IShiftUnfilledPanelProps {
  /** Subtitle under the heading — status-specific, from `toUnfilledDescription`. */
  description: string;
}

/**
 * The primary column for a terminal shift nobody was booked on.
 *
 * The empty state is the design system's own: in Figma this frame *is* a
 * `CandidateTopper` variant rather than a separate component, and since
 * `react-blocks@0.16.0` the block ships that variant as
 * `topperStyle="cancelled-unfilled"` — the mint tooth avatar, the title and the
 * description, laid out and tokenised there.
 *
 * Only the description is overridden. The block's default says the shift "was
 * cancelled", which is wrong on one that merely expired, so the page derives
 * the sentence from the status and passes it in — see `toUnfilledDescription`.
 */
export const ShiftUnfilledPanel = ({ description }: IShiftUnfilledPanelProps) => (
  <DetailsPanel data-testid="shift-unfilled-panel" data-cy="shift-unfilled-panel">
    <CandidateTopper
      topperStyle="cancelled-unfilled"
      unfilledDescription={description}
      testID="shift-unfilled-topper"
    />
  </DetailsPanel>
);
